import { prepareOrganizationId } from '@/appLogic/initializers/organizationId';

/**
 *
 */
export default async () => {
  await prepareOrganizationId();
};
